import React, { useState, useEffect } from 'react';
import { FaRuler } from 'react-icons/fa';
import * as cornerstone from 'cornerstone-core';
import * as cornerstoneTools from 'cornerstone-tools';
import { ControlsContainer, IconButton } from './styles';

const MeasurementControls = ({ imageElement, onMeasuringChange, isMeasuring }) => {
  const [isActive, setIsActive] = useState(false);

  // Reset measurement tool when image element changes or isMeasuring changes
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (imageElement && !isMeasuring && isActive) {
      setIsActive(false);
      try {
        cornerstoneTools.setToolPassiveForElement(imageElement, 'Length');
        cornerstone.updateImage(imageElement);
      } catch (error) {
        console.error('Error resetting measurement tool:', error);
      }
    }
  }, [imageElement, isMeasuring]);

  const handleMeasurementClick = () => {
    if (!imageElement) {
      console.error('Image element not available');
      return;
    }

    try {
      const newIsActive = !isActive;
      setIsActive(newIsActive);
      onMeasuringChange(newIsActive);

      if (newIsActive) {
        // Ensure the tool is added to the element
        if (!cornerstoneTools.isToolActiveForElement(imageElement, 'Length')) {
          cornerstoneTools.addToolForElement(imageElement, cornerstoneTools.LengthTool);
        }
        // Activate the tool with left mouse button
        cornerstoneTools.setToolActiveForElement(imageElement, 'Length', { mouseButtonMask: 1 });
      } else {
        // Set tool to passive state when deactivated
        cornerstoneTools.setToolPassiveForElement(imageElement, 'Length');
      }

      // Force image update to reflect changes
      cornerstone.updateImage(imageElement);
    } catch (error) {
      console.error('Error toggling measurement tool:', error);
      setIsActive(false);
      onMeasuringChange(false);
    }
  };

  return (
    <ControlsContainer>
      <IconButton onClick={handleMeasurementClick} active={isActive} title="Medir distância">
        <FaRuler />
      </IconButton>
    </ControlsContainer>
  );
};

export default MeasurementControls;
